const autocompleteFieldFormikStyle = {
  checkbox: {
    marginRight: 8,
  },
};

export default autocompleteFieldFormikStyle;
